export default "__VITE_ASSET__DbNjsFnO__"